import { createUseStyles } from 'react-jss';

import { FontWeight } from '../../../../styles';
import { ITheme } from '../../../../styles/theme';

const useStyles = createUseStyles<string, { size: 'large' | 'small'; hasBorder: boolean }>(
  ({ colors, breakpoints }: ITheme) => ({
    button: {
      '&[data-reach-listbox-button]': {
        background: 'var(--x-bg-1)',

        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: ({ hasBorder }) => (hasBorder ? '1px solid #CBCBCB' : 'none'),
        cursor: 'pointer',
        transition: `border 0.3s ease-in-out`,
        color: colors.textField,

        fontWeight: FontWeight.Regular,
        zIndex: 10,
        position: 'relative',
        lineHeight: '28px',

        '&.disabled': {
          background: '#f8f8f8',
          color: '#C9C9C9',
          borderColor: '#f8f8f8',
        },

        borderRadius: ({ size }) => (size === 'large' ? '16px' : '8px'),
        padding: ({ size }) => (size === 'large' ? '20px 24px' : '12px 16px'),
        fontSize: ({ size }) => (size === 'large' ? '20px' : '12px'),

        '&:hover, &:focus-visible': {
          border: ({ hasBorder }) => hasBorder && `1px solid var(--x-black)`,
          outline: 0,
        },

        '& [data-reach-listbox-arrow]': {
          color: 'red',
          display: 'inline-block',
          width: '20px',
          verticalAlign: 'middle',

          '& i': {
            verticalAlign: 'middle',
          },
        },
      },
    },
    popover: {
      '&[data-reach-listbox-popover]': {
        maxHeight: '300px',
        overflowX: 'hidden',
        overflowY: 'auto',
        marginTop: '8px',
        boxShadow: '0px 1px 4px 0px var(--x-shadow-card)',
        background: 'var(--x-bg-1)',
        zIndex: '1000',

        borderRadius: ({ size }) => (size === 'large' ? '10px' : '8px'),
        padding: ({ size }) => (size === 'large' ? '13px 12px' : '11px 10px'),

        '& li': {
          color: 'var(--x-bg-4)',
          listStyle: 'none',
          fontWeight: FontWeight.SemiBold,
          cursor: 'pointer',
          lineHeight: '24px',

          borderRadius: ({ size }) => (size === 'large' ? '8px' : '6px'),
          padding: ({ size }) => (size === 'large' ? '6px 10px' : '4px 8px'),
          fontSize: ({ size }) => (size === 'large' ? '22px' : '16px'),
        },

        '& li:hover, [data-current-nav]': {
          background: 'var(--x-accent-1-5)',
          color: 'var(--x-accent-1-1)',
        },

        '& ul:focus-visible': {
          outline: 'none',
        },

        '&:focus-within': {
          boxShadow: '0px 1px 4px 0px var(--x-shadow-card)',
          outline: 'none',
        },
      },
    },
    label: {
      display: 'block',
      fontWeight: FontWeight.SemiBold,
      color: 'var(--x-black-1)',
      margin: '0 0 8px 0',
      fontSize: ({ size }) => (size === 'large' ? '16px' : '12px'),
      lineHeight: '16px',
    },
  }),
  {
    name: 'dropdown',
  },
);

export default useStyles;
